/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function(){
  $('.main-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    dots: false,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/left-arr.png?v=1607019623'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/rit-arr.png?v=1607019633'>",
    asNavFor: '.thumb-images',
    adaptiveHeight: true
  });
  $('.thumb-images').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-images',
    dots: false,
    arrows: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/left-arr.png?v=1607019623'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0247/9115/4785/t/27/assets/rit-arr.png?v=1607019633'>",
    focusOnSelect: true
  });
  
  var img_heught = $(".prd_img img").height();
  $(".main-images .slick-slide iframe").height(img_heught);

});

/* Google Ads Add to Cart conversion tracking.
 * Fires once after each successful Shopify /cart/add request. This shared
 * asset covers native Shopify and GemPages layouts without page-by-page edits.
 */
(function installOldisGoogleAdsAddToCartTracker() {
  'use strict';

  if (window.__oldisGoogleAdsAddToCartTrackerInstalled) return;
  window.__oldisGoogleAdsAddToCartTrackerInstalled = true;

  var conversionDestination = 'AW-928960530/khJtCM_w69McEJKg-7oD';

  function isShopifyCartAdd(url, method) {
    if (!url || String(method || 'GET').toUpperCase() !== 'POST') return false;

    try {
      var pathname = new URL(String(url), window.location.origin).pathname;
      return /\/cart\/add(?:\.js|\.json)?\/?$/.test(pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js|\.json)?(?:[?#]|$)/.test(String(url));
    }
  }

  function reportSuccessfulAddToCart() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
      window.dataLayer.push(arguments);
    };

    window.gtag('event', 'conversion', {
      send_to: conversionDestination
    });
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;

    window.fetch = function(input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var requestMethod = init && init.method
        ? init.method
        : input && input.method
          ? input.method
          : 'GET';
      var cartAddRequest = isShopifyCartAdd(requestUrl, requestMethod);

      return originalFetch.apply(this, arguments).then(function(response) {
        if (cartAddRequest && response && response.ok) {
          reportSuccessfulAddToCart();
        }
        return response;
      });
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function(method, url) {
      this.__oldisGoogleAdsCartAddRequest = isShopifyCartAdd(url, method);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function() {
      if (this.__oldisGoogleAdsCartAddRequest) {
        this.addEventListener('load', function() {
          if (this.status >= 200 && this.status < 300) {
            reportSuccessfulAddToCart();
          }
        }, { once: true });
      }

      return originalSend.apply(this, arguments);
    };
  }
})();